import { render, staticRenderFns } from "./PartsControlNewManualPurchaseOrder.vue?vue&type=template&id=0227f45a&scoped=true"
import script from "./PartsControlNewManualPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./PartsControlNewManualPurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./PartsControlNewManualPurchaseOrder.vue?vue&type=style&index=0&id=0227f45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0227f45a",
  null
  
)

export default component.exports